/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-boolean-value */
import React, { useState, useContext, useEffect, useMemo } from 'react';
import {
    Button,
    Dialog,
    Grid,
    IconButton,
    Stack,
    TextField,
    Typography,
    FormControl,
    Chip,
    Autocomplete,
    Divider,
    InputLabel,
    Select,
    MenuItem,
    Card,
    CardContent,
    Drawer,
    Tooltip,
    Box,
    DialogTitle,
    DialogContent,
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Pagination,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import BusinessIcon from '@mui/icons-material/Business';
import FactoryIcon from '@mui/icons-material/Factory';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Info from '@mui/icons-material/Info';
import { Place } from '@mui/icons-material';
import NearMeIcon from '@mui/icons-material/NearMe';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import moment from 'moment';
import MapComponent from '../../components/TrackerMap/Map'
import UIContext from '../../context/UIContext';
import './animation.css';
import axios from '../../utils/axios';
import NoResultsFound from '../../components/NoResultsFound';
import 'leaflet/dist/leaflet.css';
import factoryIconUrl from '../../media/factory.png'; // Ensure you have this image in your project
import NotSyncedImage from '../../pages/notsynced2.png';


// Factory icon for the map marker
const factoryIcon = new L.Icon({
    iconUrl: factoryIconUrl,
    iconSize: [70, 70],
    iconAnchor: [35, 70],
    popupAnchor: [0, -32],
});

const filterInitialValue = {
    FromDate: moment().startOf('month').format('YYYY-MM-DD'),
    ToDate: moment().format('YYYY-MM-DD'),
    Buyer: { BuyerId: 0, Buyer: 'All Buyers' },
    Factory: { AccId: 0, AccName: 'All Factories' },
    Style: { StyleNo: 'All Styles' },
    InspectionType: { InspectionTypeId: 0, InspectionType: 'All Inspection Types' },
    Result: 0,
    Status: 0,
    Inspector: { UserId: 0, LoginName: 'All Inspectors' },
    AssistQa: { UserID: 0, LoginName: 'All Assiting QA' },
    Coordinator: { UserID: 0, LoginName: 'All Coordinators' },
    InspectionNo: { QAInspectionId: 0, InspectionNo: 'All Inspection No' },
};

// Function to calculate new center based on an offset
const offsetCenter = (map, lat, lng, xPercent, yPercent) => {
    if (!map) return [lat, lng]; // Return original coords if map is not available

    const mapSize = map.getSize();
    const xOffset = (xPercent / 100) * mapSize.x;
    const yOffset = (yPercent / 100) * mapSize.y;

    const targetPoint = map.latLngToContainerPoint([lat, lng]);
    const newPoint = L.point(targetPoint.x - xOffset, targetPoint.y - yOffset);
    const newLatLng = map.containerPointToLatLng(newPoint);

    return [newLatLng.lat, newLatLng.lng];
};

// Component to adjust the center of the map
const AdjustMapCenter = ({ latitude, longitude }) => {
    const map = useMap();

    useEffect(() => {
        if (latitude && longitude) {
            const [newLat, newLng] = offsetCenter(map, latitude, longitude, 20, 10);
            map.setView([newLat, newLng], 13, { animate: true, duration: 1 }); // Smooth animation
        }
    }, [latitude, longitude, map]);

    return null;
};

// Main Inspection Tracker Component
const FabricInspectionTracker = () => {
    const [filterData, setFilterData] = useState(filterInitialValue);
    const [Inspections, setInspections] = useState([]);
    const [SelectedInspection, setSelectedInspection] = useState(null);
    const [Location, setLocation] = useState({ latitude: 0, longitude: 0 });
    const [showInspectionDetails, setShowInspectionDetails] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [getInspectionFlag, setGetInspectionFlag] = useState(false);
    const [TrackingDetail, setTrackingDetail] = useState([]);
    const [openTrackingDetail, setOpenTrackingDetail] = useState(false);
    const [filterStyles, setFilterStyles] = useState([]);
    const [filterInspectors, setFilterInspectors] = useState([]);
    const [filterInspectionTypes, setFilterInspectionTypes] = useState([]);
    const [buyers, setBuyers] = useState([]);
    const [factories, setFactories] = useState([]);
    const [users, setUsers] = useState([]);
    const [inspectionNo, setInspectionNo] = useState([]);
    const [page, setPage] = useState(1);
    const [sidebarOpen, setSidebarOpen] = useState(true); // State to control sidebar visibility
    const [brokenImages, setBrokenImages] = useState({});

    const ITEMS_PER_PAGE = 3;

    const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

    const handleMarkerClick = () => {
        setShowInspectionDetails(true);
    };

    // Inspection Details Card
    const InspectionDetailsCard = ({ inspection, onClose, GetAllTrackingDetail }) => {
        return (
            <Grid container columnSpacing={1} rowSpacing={0} spacing={0} alignItems="center" p={1}>
                <Grid item xs={6}>
                    <Stack direction="row" justifyContent={'start'} alignItems={'center'} spacing={1}>
                        <AssignmentIcon fontSize="x-small" sx={{ color: '#1976d2', mr: 1 }} />
                        <Typography variant="caption">{inspection?.InspectionCode}</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={6}>
                    <Stack direction="row" justifyContent={'start'} alignItems={'center'} spacing={1}>
                        <CalendarTodayIcon fontSize="x-small" sx={{ color: '#1976d2', mr: 1 }} />
                        <Typography variant="caption">{inspection?.QAInspectionDate}</Typography>
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <Stack direction="row" justifyContent={'start'} alignItems={'center'} spacing={1}>
                        <BusinessIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                        <Typography variant="body2">{inspection?.Buyer}</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <Stack direction="row" justifyContent={'start'} alignItems={'center'} spacing={1}>
                        <FactoryIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                        <Typography variant="body2">{inspection?.Factory}</Typography>
                    </Stack>
                </Grid>
                {inspection?.FactoryLatitude && inspection?.FactoryLongitude && (
                    <Grid item xs={12}>
                        <Stack direction="row" justifyContent={'start'} alignItems={'center'} spacing={1}>
                            <NearMeIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                            <Typography variant="body2">
                                Distance from factory :{' '}
                                {findDistance(
                                    inspection?.Latitude,
                                    inspection?.Longitude,
                                    inspection?.FactoryLatitude,
                                    inspection?.FactoryLongitude
                                )}
                            </Typography>
                        </Stack>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <Stack direction="row" justifyContent={'space-between'} alignItems={'center'} spacing={1}>
                        {inspection?.IsCompleted === 'Y' && (
                            <Chip
                                color={
                                    inspection?.InspectionStatus?.trim() === 'P'
                                        ? 'success'
                                        : inspection?.InspectionStatus?.trim() === 'F'
                                            ? 'error'
                                            : 'warning'
                                }
                                label={
                                    inspection?.InspectionStatus?.trim() === 'P' ? 'Pass' : inspection?.InspectionStatus?.trim() === 'F' ? 'Fail' : 'Hold'
                                }
                                sx={{
                                    width: '100%',
                                }}
                                size="small"
                                variant="filled"
                            />
                        )}
                        <Chip
                            icon={
                                inspection?.IsCompleted === 'Y' ? (
                                    <CheckCircleOutlineIcon fontSize="small" />
                                ) : inspection?.IsCompleted === 'N' ? (
                                    <AutorenewIcon fontSize="small" />
                                ) : (
                                    <AccessTimeIcon fontSize="small" />
                                )
                            }
                            label={
                                inspection?.IsCompleted === 'Y'
                                    ? 'Completed'
                                    : inspection?.IsCompleted === 'N'
                                        ? 'In-Progress'
                                        : 'Pending'
                            }
                            color={inspection?.IsCompleted === 'Y' ? 'success' : inspection?.IsCompleted === 'N' ? 'info' : 'warning'}
                            size="small"
                            variant="outlined"
                            sx={{ width: '100%' }}
                        />
                        <IconButton onClick={GetAllTrackingDetail}>
                            <Info color="primary" />
                        </IconButton>
                    </Stack>
                </Grid>
            </Grid>
        );
    };
    const GetAllTrackingDetail = async () => {
        try {
            showLoading();
            const response = await axios.post('FabricInspection/InspectionTracker/GetAllFabricInspectionTrackerDetails', {
                FabricInspectionId: SelectedInspection.FabricInspectionId,
            });
            setTrackingDetail(response.data);

            setOpenTrackingDetail(true);
        } catch (e) {
            openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
        }
        hideLoading();
    };

    const mapMarkers = useMemo(() => {
        return Inspections.filter(inspection => inspection.Latitude && inspection.Longitude)
            .map(inspection => ({
                latitude: inspection.Latitude,
                longitude: inspection.Longitude,
                inspection,
                popupContent: (
                    <InspectionDetailsCard
                        inspection={inspection}
                        GetAllTrackingDetail={GetAllTrackingDetail}
                    />
                )
            }));
    }, [Inspections]);

    const handleToggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    const getInspectionTracking = async (inspection) => {
        // console.log(inspection);
        if (!inspection.Longitude || !inspection.Latitude) {
            setSelectedInspection(null);
            return;
        }

        // Set the new location with smooth animation
        setLocation({
            longitude: inspection.Longitude,
            latitude: inspection.Latitude,
        });

        setSelectedInspection(inspection);
    };

    const GetAllHelpData = async () => {
        try {
            showLoading();
            const resData = await axios.get('ReferenceData/GetAllBuyers');
            const resData1 = await axios.get('ReferenceData/GetAllFactories');
            const resData2 = await axios.post('Master/User/GetAllSupervisor', { UserId: sessionStorage.getItem('UserId') });
            const resData3 = await axios.get('Master/InspectionType/GetAllInspectionType');
            const resData4 = await axios.get('Master/User/GetAllActiveUser');
            const resData5 = await axios.get('Transaction/InspectionHeader/GetAllInspectionNo');

            setBuyers(resData.data);
            setFactories(resData1.data);
            setFilterInspectors(resData2.data);
            setFilterInspectionTypes(resData3.data);
            setUsers(resData4.data);
            setInspectionNo(resData5.data);
        } catch (e) {
            openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
        }
        hideLoading();
    };

    const getAllInspection = async () => {
        try {
            showLoading();
            const response = await axios.post('FabricInspection/InspectionTracker/GetAllFabricInspectionTracker',
                {
                    FromDate: moment(filterData.FromDate).format('YYYYMMDD'),
                    ToDate: moment(filterData.ToDate).format('YYYYMMDD'),
                    FactoryId: filterData.Factory.AccId,
                    BuyerId: filterData.Buyer.BuyerId,
                    StyleNo: filterData.Style.StyleNo === 'All Styles' ? 0 : filterData.Style.StyleNo,
                    InspectorId: filterData.Inspector.UserId,
                    AssistQAId: filterData.AssistQa.UserID,
                    CoordinatorId: filterData.Coordinator.UserID,
                    InspectionTypeId: filterData.InspectionType.InspectionTypeId,
                    InspectionNo:
                        filterData.InspectionNo.InspectionNo === filterInitialValue.InspectionNo.InspectionNo
                            ? 0
                            : filterData.InspectionNo.InspectionNo,
                    Result: filterData.Result,
                    Status: filterData.Status,
                    UserId: sessionStorage.getItem('UserId'),
                });
            setInspections(response.data);
            setGetInspectionFlag(true);
            setOpenFilter(false);
            setSelectedInspection(null);
        } catch (e) {
            openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
        }
        hideLoading();
    };

    const getStyleNo = async () => {
        try {
            if (!filterData.Buyer.BuyerId || !filterData.Factory.AccId) return;
            const response = await axios.post('ReferenceData/GetAllStyles', {
                FactoryId: filterData.Factory.AccId,
                BuyerId: filterData.Buyer.BuyerId,
            });
            setFilterData({ ...filterData, Style: { StyleNo: 'All Styles' } });
            setFilterStyles(response.data);
        } catch (e) {
            openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
        }
    };

    useEffect(() => {
        getStyleNo();
    }, [filterData.Buyer, filterData.Factory]);

    useEffect(() => {
        GetAllHelpData();
    }, []);

    const totalPages = useMemo(() => {
        setPage(1);
        return Math.ceil(Inspections.length / ITEMS_PER_PAGE);
    }, [Inspections]);

    const displayedInspections = useMemo(
        () => Inspections.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE),
        [Inspections, page]
    );

    const deg2rad = (deg) => {
        return deg * (Math.PI / 180);
    };

    const findDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371; // Radius of the earth in km
        const dLat = deg2rad(lat2 - lat1); // deg2rad below
        const dLon = deg2rad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c; // Distance in km
        return `${d.toFixed(2)} Km` || 'N/A';
        // const distanceInMeters = d * 1000;
        // return `${distanceInMeters.toFixed(2)} m` || 'N/A';
    };

    const handleImageError = (imageName) => {
        setBrokenImages((prev) => ({ ...prev, [imageName]: true }));
    };



    return (
        <>
            {/* Filter Inputs */}
            <Drawer
                anchor="top"
                open={openFilter}
                onClose={() => {
                    setOpenFilter(false);
                }}
            >
                <Grid container spacing={2} p={3} rowSpacing={2} columnSpacing={1}>
                    <Grid item md={2} xs={12}>
                        {/* From Date */}
                        <TextField
                            fullWidth
                            label="From Date"
                            type="date"
                            name="fromDate"
                            value={filterData.FromDate}
                            onChange={(e) => {
                                setFilterData({ ...filterData, FromDate: e.target.value });
                            }}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            inputProps={{ max: '9999-12-31' }}
                        />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        {/* To Date */}
                        <TextField
                            fullWidth
                            label="To Date"
                            type="date"
                            name="ToDate"
                            value={filterData.ToDate}
                            onChange={(e) => {
                                setFilterData({ ...filterData, ToDate: e.target.value });
                            }}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            inputProps={{ max: '9999-12-31' }}
                        />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Autocomplete
                            options={[filterInitialValue.Factory, ...factories]}
                            getOptionLabel={(factory) => factory.AccName}
                            isOptionEqualToValue={(value) => value.AccId === filterData.Factory.AccId}
                            renderOption={(props, factory) => (
                                <li {...props} key={factory.AccId}>
                                    {factory.AccName}
                                </li>
                            )}
                            value={filterData.Factory || null}
                            name="Factory"
                            onChange={(event, value) => {
                                setFilterData({ ...filterData, Factory: value });
                            }}
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} label="Factory" />}
                        />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Autocomplete
                            options={[filterInitialValue.Buyer, ...buyers]}
                            getOptionLabel={(buyers) => buyers.Buyer}
                            isOptionEqualToValue={(value) => value.BuyerId === filterData.Buyer?.BuyerId}
                            renderOption={(props, buyers) => (
                                <li {...props} key={buyers.BuyerId}>
                                    {buyers.Buyer}
                                </li>
                            )}
                            value={filterData.Buyer}
                            name="Buyer"
                            onChange={(event, value) => {
                                setFilterData({ ...filterData, Buyer: value });
                            }}
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} label="Buyer" />}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Autocomplete
                            options={[filterInitialValue.Style, ...filterStyles]}
                            getOptionLabel={(styles) => styles.StyleNo}
                            isOptionEqualToValue={(value) => value.StyleNo === filterData.Style.StyleNo}
                            renderOption={(props, styles) => (
                                <li {...props} key={styles.StyleNo}>
                                    {styles.StyleNo}
                                </li>
                            )}
                            value={filterData.Style || null}
                            name="Style"
                            onChange={(event, value) => {
                                setFilterData({ ...filterData, Style: value });
                            }}
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} label="Style No" />}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Autocomplete
                            options={[filterInitialValue.Inspector, ...filterInspectors]}
                            getOptionLabel={(inspector) => inspector.LoginName}
                            isOptionEqualToValue={(value) => value.UserId === filterData.Inspector.UserId}
                            renderOption={(props, user) => (
                                <li {...props} key={user.UserId}>
                                    {user.LoginName} {user.Designation ? ` ( ${user.Designation} ) ` : ''}
                                </li>
                            )}
                            value={filterData.Inspector || null}
                            name="Inspector"
                            onChange={(event, value) => {
                                setFilterData({ ...filterData, Inspector: value });
                            }}
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} label="Inspector" />}
                        />
                    </Grid>

                    <Grid item md={3} xs={12}>
                        <Autocomplete
                            options={[filterInitialValue.AssistQa, ...users]}
                            getOptionLabel={(inspector) => inspector.LoginName}
                            isOptionEqualToValue={(value) => value.UserID === filterData.AssistQa.UserID}
                            renderOption={(props, user) => (
                                <li {...props} key={user.UserID}>
                                    {user.LoginName} {user.Designation ? ` ( ${user.Designation} ) ` : ''}
                                </li>
                            )}
                            value={filterData.AssistQa || null}
                            name="AssistQa"
                            onChange={(event, value) => {
                                setFilterData({ ...filterData, AssistQa: value });
                            }}
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} label="Assist QA" />}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Autocomplete
                            options={[filterInitialValue.Coordinator, ...users]}
                            getOptionLabel={(inspector) => inspector.LoginName}
                            isOptionEqualToValue={(value) => value.UserID === filterData.Coordinator.UserID}
                            renderOption={(props, user) => (
                                <li {...props} key={user.UserID}>
                                    {user.LoginName} {user.Designation ? ` ( ${user.Designation} ) ` : ''}
                                </li>
                            )}
                            value={filterData.Coordinator || null}
                            name="Production Coordinator"
                            onChange={(event, value) => {
                                setFilterData({ ...filterData, Coordinator: value });
                            }}
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} label="Production Coordinator" />}
                        />
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <Autocomplete
                            options={[filterInitialValue.InspectionNo, ...inspectionNo]}
                            getOptionLabel={(inspec) => inspec.InspectionNo}
                            isOptionEqualToValue={(value) => value.QAInspectionId === filterData.InspectionNo?.QAInspectionId}
                            renderOption={(props, inspec) => (
                                <li {...props} key={inspec.QAInspectionId}>
                                    {inspec.InspectionNo}
                                </li>
                            )}
                            value={filterData.InspectionNo}
                            name="InspectionNo"
                            onChange={(event, value) => {
                                setFilterData({ ...filterData, InspectionNo: value });
                            }}
                            size="small"
                            disableClearable
                            renderInput={(params) => <TextField {...params} label="Inspection No" />}
                        />
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Result</InputLabel>
                            <Select
                                value={filterData.Result}
                                name="Result"
                                size="small"
                                label="Result"
                                onChange={(event) => {
                                    setFilterData({ ...filterData, Result: event.target.value });
                                }}
                            >
                                {[
                                    { value: '0', label: 'All Result' },
                                    { value: 'P', label: 'Pass' },
                                    { value: 'F', label: 'Fail' },
                                ].map((option, i) => (
                                    <MenuItem key={option.label} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Status</InputLabel>
                            <Select
                                value={filterData.Status}
                                name="Status"
                                size="small"
                                label="Status"
                                onChange={(event) => {
                                    setFilterData({ ...filterData, Status: event.target.value });
                                }}
                            >
                                {[
                                    { value: '0', label: 'All Status' },
                                    { value: 'I', label: 'In-Progress' },
                                    { value: 'C', label: 'Completed' },
                                ].map((option, i) => (
                                    <MenuItem key={option.label} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2} sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={() => {
                                getAllInspection();
                            }}
                            sx={{ boxShadow: 0 }}
                        >
                            View
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            fullWidth
                            onClick={() => {
                                setOpenFilter(false);
                            }}
                            sx={{ boxShadow: 0 }}
                        >
                            Close
                        </Button>
                    </Grid>
                </Grid>
            </Drawer>

            {/* Map and Sidebar Container */}
            <Box sx={{ display: 'flex', height: '100%', width: '100%' }}>
                {/* Sidebar for Inspection Results */}
                {displayedInspections.length !== 0 && (
                    <Box
                        sx={{
                            width: sidebarOpen ? 700 : 0,
                            transition: 'width 0.3s ease-in-out',
                            overflow: 'hidden',
                            backgroundColor: 'background.paper',
                            borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                        }}
                    >
                        {displayedInspections.length !== 0 && (
                            <Box sx={{ p: 1 }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#00879E' }} className="font_style_branch">
                                    Filtered Results - Fabric Inspections
                                </Typography>
                                <Divider sx={{ my: 1 }} />
                                <Box>
                                    <Stack p={2} pb={2} gap={2} sx={{ maxHeight: '70vh', overflow: 'auto' }}>
                                        {displayedInspections.map((inspection, index) => (
                                            <Card
                                                key={index}
                                                sx={{
                                                    boxShadow: 5,
                                                    borderRadius: 2,
                                                    cursor: 'pointer',
                                                    flexShrink: 0,
                                                    transition: 'transform 0.2s ease-in-out',
                                                    '&:hover': {
                                                        transform: 'scale(1.05)',
                                                        boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
                                                    },
                                                }}
                                                onClick={() => {
                                                    getInspectionTracking(inspection);
                                                }}
                                            >
                                                <CardContent sx={{ pb: '0 !important', p: 1 }}>
                                                    {/* Inspection Information */}
                                                    <Grid container spacing={0} alignItems="center">
                                                        <Grid item md={3} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <AssignmentIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                                                            <Typography variant="body2">{inspection.InspectionCode}</Typography>
                                                        </Grid>
                                                        <Grid item md={3} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <CalendarTodayIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                                                            <Typography variant="body2">{inspection.QAInspectionDate}</Typography>
                                                        </Grid>

                                                        <Grid display="flex" gap={1} justifyContent="end" item md={6} xs={12}>
                                                            {inspection.IsCompleted === 'Y' && (
                                                                <Chip
                                                                    color={
                                                                        inspection.InspectionStatus?.trim() === 'P'
                                                                            ? 'success'
                                                                            : inspection.InspectionStatus?.trim() === 'F'
                                                                                ? 'error'
                                                                                : 'warning'
                                                                    }
                                                                    label={
                                                                        inspection.InspectionStatus?.trim() === 'P'
                                                                            ? 'Pass'
                                                                            : inspection.InspectionStatus?.trim() === 'F'
                                                                                ? 'Fail'
                                                                                : 'Hold'
                                                                    }
                                                                    size="small"
                                                                    variant="contain"
                                                                />
                                                            )}
                                                            <Chip
                                                                icon={
                                                                    inspection.IsCompleted === 'Y' ? (
                                                                        <CheckCircleOutlineIcon fontSize="small" />
                                                                    ) : inspection.IsCompleted === 'N' ? (
                                                                        <AutorenewIcon fontSize="small" />
                                                                    ) : (
                                                                        <AccessTimeIcon fontSize="small" />
                                                                    )
                                                                }
                                                                label={
                                                                    inspection.IsCompleted === 'Y'
                                                                        ? 'Completed'
                                                                        : inspection.IsCompleted === 'N'
                                                                            ? 'In-Progress'
                                                                            : 'Pending'
                                                                }
                                                                color={
                                                                    inspection.IsCompleted === 'Y'
                                                                        ? 'success'
                                                                        : inspection.IsCompleted === 'N'
                                                                            ? 'info'
                                                                            : 'warning'
                                                                }
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <BusinessIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                                                            <Typography variant="body2">{inspection.Buyer}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <FactoryIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                                                            <Typography variant="body2">{inspection.Factory}</Typography>
                                                        </Grid>
                                                        {inspection?.FactoryLatitude && inspection?.FactoryLongitude && (
                                                            <Grid item xs={12}>
                                                                <Stack direction="row" justifyContent={'start'} alignItems={'center'} spacing={1}>
                                                                    <NearMeIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                                                                    <Typography variant="body2">
                                                                        Distance from factory :{' '}
                                                                        {findDistance(
                                                                            inspection?.Latitude,
                                                                            inspection?.Longitude,
                                                                            inspection?.FactoryLatitude,
                                                                            inspection?.FactoryLongitude
                                                                        )}
                                                                    </Typography>
                                                                </Stack>
                                                            </Grid>
                                                        )}
                                                        <Grid item xs={12}>
                                                            <Divider sx={{ mt: 1 }} />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                gap: 1,
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <Box flexGrow={1}>
                                                                <Typography variant="subtitle2" fo>
                                                                    IPO Style No
                                                                </Typography>
                                                                <Typography variant="caption">{inspection.Style || 'N / A'}</Typography>
                                                            </Box>
                                                            <Divider orientation="vertical" variant="middle" flexItem />
                                                            <Box flexGrow={1}>
                                                                <Typography variant="subtitle2">Auditor</Typography>
                                                                <Typography variant="caption">{inspection.Auditor}</Typography>
                                                            </Box>
                                                            {/* <Box flexGrow={1}>
                                <Typography variant="subtitle2">Inspection Type</Typography>
                                <Typography variant="caption">{inspection.InspectionType || 'N / A'}</Typography>
                              </Box> */}
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Divider />
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                gap: 1,
                                                                textAlign: 'center',
                                                            }}
                                                        >

                                                            {/* <Divider orientation="vertical" variant="middle" flexItem /> */}
                                                            <Box flexGrow={1}>
                                                                <Typography variant="subtitle2">Assist QA</Typography>
                                                                <Typography variant="caption">{inspection.AssistQAs || 'N / A'}</Typography>
                                                            </Box>
                                                            <Divider orientation="vertical" variant="middle" flexItem />
                                                            <Box flexGrow={1}>
                                                                <Typography variant="subtitle2">Coordinator</Typography>
                                                                <Typography variant="caption">{inspection.Coordinators || 'N / A'}</Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        ))}
                                    </Stack>
                                    {totalPages > 1 && (
                                        <Pagination
                                            count={totalPages}
                                            page={page}
                                            onChange={(event, value) => setPage(value)}
                                            color="primary"
                                            sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
                                        />
                                    )}
                                </Box>
                                {displayedInspections.length === 0 && <NoResultsFound />}
                            </Box>
                        )}
                    </Box>
                )}
                {/* Map Component */}
                {/* <MapContainer
          zoomControl={false}
          center={[Location.latitude || 13.0843, Location.longitude || 80.2705]}
          zoom={25}
          style={{
            height: '100%',
            width: '100%',
          }}
          scrollWheelZoom={true}
         >
          <Box direction={'column'} p={2} sx={{ maxWidth: '60px' }}>
            {displayedInspections.length !== 0 && (
              <Tooltip title="Open Results">
                <IconButton
                  sx={{
                    background: 'white',
                    boxShadow: 3,
                    '&:hover': {
                      background: 'white',
                    },
                    zIndex: 1000,
                    transition: 'left 0.3s ease-in-out',
                  }}
                  onClick={() => setSidebarOpen(!sidebarOpen)}
                  color="primary"
                >
                  <SwapHorizontalCircleIcon />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Inspection filters">
              <IconButton
                sx={{
                  background: 'white',
                  boxShadow: 3,
                  '&:hover': {
                    background: 'white',
                  },
                  zIndex: 1000,
                  transition: 'left 0.3s ease-in-out',
                  marginTop: 1,
                }}
                mt={5}
                onClick={() => setOpenFilter(true)}
                color="warning"
              >
                <FilterAltIcon color="warning" />
              </IconButton>
            </Tooltip>
          </Box>

          <AdjustMapCenter latitude={Location.latitude} longitude={Location.longitude} />
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />

          {/* Marker for the given location */}
                {/* {SelectedInspection && (
            <Marker
              icon={factoryIcon}
              position={[Location.latitude, Location.longitude]}
              eventHandlers={{
                click: () => handleMarkerClick(),
              }}
            >
              <Popup className="custom-popup">
                <InspectionDetailsCard inspection={SelectedInspection} GetAllTrackingDetail={GetAllTrackingDetail} />
              </Popup>
            </Marker>
          )} */}
                {/* </MapContainer> */}
                <MapComponent
                    center={!!SelectedInspection?.Latitude && !!SelectedInspection?.Longitude ?
                        [SelectedInspection.Latitude, SelectedInspection.Longitude] : undefined
                    }
                    zoom={25}
                    MarkerPopup={<InspectionDetailsCard
                        inspection={SelectedInspection}
                        GetAllTrackingDetail={GetAllTrackingDetail}
                    />}
                    hasMarkerLocation={!!SelectedInspection?.Latitude && !!SelectedInspection?.Longitude}
                    onMarkerClick={handleMarkerClick}
                    onToggleSidebar={handleToggleSidebar}
                    onOpenFilter={() => setOpenFilter(true)}
                    showSidebarToggle={displayedInspections.length !== 0}
                />
            </Box>

            {/* Tracking Details Popup */}
            <Dialog open={openTrackingDetail} maxWidth="md">
                <DialogTitle>
                    <Stack direction="row" justifyContent="space-between" spacing={0} alignItems="center">
                        <Stack direction="row" alignItems="center">
                            <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1F7D53' }} className="font_style_branch">
                                Fabric Inspection Timeline
                            </Typography>
                            {/* {SelectedInspection?.IsCompleted === 'N' && ( */}
                            <IconButton onClick={GetAllTrackingDetail}>
                                <RefreshIcon sx={{ fontWeight: 'bold', color: '#1F7D53' }} />
                            </IconButton>
                            {/* )} */}
                        </Stack>
                        <IconButton
                            onClick={() => {
                                setOpenTrackingDetail(false);
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <Grid container spacing={0} p={1} alignItems="center" columnSpacing={1}>
                        <Grid item md={3} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                            <AssignmentIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                            <Typography variant="body1">{SelectedInspection?.InspectionCode}</Typography>
                        </Grid>
                        <Grid item md={3} xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                            <CalendarTodayIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                            <Typography variant="body1">{SelectedInspection?.QAInspectionDate}</Typography>
                        </Grid>
                        {SelectedInspection?.IsCompleted === 'Y' && (
                            <Grid item md={3} xs={9} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                <Chip
                                    color={
                                        SelectedInspection?.InspectionStatus?.trim() === 'P'
                                            ? 'success'
                                            : SelectedInspection?.InspectionStatus?.trim() === 'F'
                                                ? 'error'
                                                : 'warning'
                                    }
                                    label={
                                        SelectedInspection?.InspectionStatus?.trim() === 'P'
                                            ? 'Pass'
                                            : SelectedInspection?.InspectionStatus?.trim() === 'F'
                                                ? 'Fail'
                                                : 'Hold'
                                    }
                                    size="small"
                                    variant="contain"
                                />
                            </Grid>
                        )}
                        <Grid justifyContent="end" item xs={3}>
                            <Chip
                                icon={
                                    SelectedInspection?.IsCompleted === 'Y' ? (
                                        <CheckCircleOutlineIcon fontSize="small" />
                                    ) : SelectedInspection?.IsCompleted === 'N' ? (
                                        <AutorenewIcon fontSize="small" />
                                    ) : (
                                        <AccessTimeIcon fontSize="small" />
                                    )
                                }
                                label={
                                    SelectedInspection?.IsCompleted === 'Y'
                                        ? 'Completed'
                                        : SelectedInspection?.IsCompleted === 'N'
                                            ? 'In-Progress'
                                            : 'Pending'
                                }
                                color={
                                    SelectedInspection?.IsCompleted === 'Y'
                                        ? 'success'
                                        : SelectedInspection?.IsCompleted === 'N'
                                            ? 'info'
                                            : 'warning'
                                }
                                size="small"
                                variant="outlined"
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <BusinessIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                            <Typography variant="body1">{SelectedInspection?.Buyer}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                            <FactoryIcon fontSize="small" sx={{ color: '#1976d2', mr: 1 }} />
                            <Typography variant="body1">{SelectedInspection?.Factory}</Typography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Stepper orientation="vertical" activeStep={TrackingDetail.length}>
                        {TrackingDetail.map((detail) => (
                            <Step key={detail.label} expanded>
                                <StepLabel sx={{ display: 'flex', gap: 1 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
                                        <Typography variant="body1"> {detail.Step}</Typography>
                                        {SelectedInspection?.FactoryLatitude && SelectedInspection?.FactoryLongitude && (
                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                <Place sx={{ fontSize: 16, color: 'text.secondary' }} />
                                                <Typography variant="body2" color="text.secondary">
                                                    Distance from factory :{' '}
                                                    {findDistance(
                                                        detail.Latitude,
                                                        detail.Longitude,
                                                        SelectedInspection.FactoryLatitude,
                                                        SelectedInspection.FactoryLongitude
                                                    )}
                                                </Typography>
                                            </Stack>
                                        )}
                                    </Stack>
                                    <Typography variant="caption">
                                        {moment.utc(detail.InspectionDateTime).local().format('YYYY-MM-DD HH:mm:ss')}
                                    </Typography>
                                </StepLabel>
                                <StepContent>
                                    <Divider />
                                    <Typography my={1} variant="body2">
                                        {' '}
                                        {detail.Message}
                                    </Typography>
                                    {detail.ImageName?.trim() && (
                                        <>
                                            <Grid mt={1} gap={2} container>
                                                {detail.ImageName.split(',').map((imageName) => {
                                                    const trimmedName = imageName.trim();
                                                    const lowerName = trimmedName.toLowerCase();
                                                    const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(lowerName); // 👈 image type check

                                                    const baseURL =
                                                        detail.Step?.replace(/\s/g, '').toLowerCase() === 'auditsummary'
                                                            ? axios.defaults.FabricInspectionAuditImageURL
                                                            : detail.Step?.replace(/\s/g, '').toLowerCase() === 'defectsummary'
                                                                ? axios.defaults.FabricInspectionDefectImageURL
                                                                : axios.defaults.FabricInspectionImageURL;

                                                    const fileUrl = `${baseURL}/${trimmedName}`;

                                                    console.log(fileUrl);


                                                    return (
                                                        <Grid item xs={4} key={trimmedName}>
                                                            {isImage ? (
                                                                brokenImages[trimmedName] ? (
                                                                    // If image is broken
                                                                    <Tooltip title="Image Not Synced Yet!">
                                                                        {/* <BrokenImageIcon color="error" style={{ fontSize: 40 }} /> */}
                                                                        {/* <SyncIcon className="rotate" fontSize="large" color="action" />  */}
                                                                        <img
                                                                            src={NotSyncedImage}
                                                                            alt="Loading...."
                                                                            style={{ width: '150px', borderRadius: 6 }}
                                                                        />
                                                                    </Tooltip>
                                                                ) : (
                                                                    <img
                                                                        src={fileUrl}
                                                                        alt={trimmedName}
                                                                        onError={() => handleImageError(trimmedName)}
                                                                        style={{ width: '100%', borderRadius: 6 }}
                                                                    />
                                                                )
                                                            ) : (
                                                                // 👇 Show a download link or icon for non-images
                                                                <Tooltip title="View Document">
                                                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                        <IconButton>
                                                                            {lowerName.endsWith('.pdf') ? (
                                                                                <PictureAsPdfIcon color="error" />
                                                                            ) : (
                                                                                <InsertDriveFileIcon color="action" />
                                                                            )}
                                                                        </IconButton>
                                                                    </a>
                                                                </Tooltip>
                                                            )}
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </>
                                    )}
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default FabricInspectionTracker;
